import React from "react";
import { Typography } from "@mui/material";
import PageHelp from "./PageHelp";

const MainTitle = ({ title, helpPageKey }) => {
  return (
    <>
      <Typography variant="h5">
        {title}
      </Typography>
      {helpPageKey && <PageHelp pageKey={helpPageKey} />}
    </>
  );
};

export default MainTitle;
